module.exports = __webpack_public_path__ + "static/media/pudong_logo.9534fe81.png";